export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=6059c3f9e63cdd478d6f5c7231ca7ca27f6d2186a0&name=fetchTypeahead!'